import { useState } from 'react';
import { useDispatch } from 'react-redux';

import { requestLogin } from '../../../api/login/login.actions';
import { requestDeleteUserDetails } from '../../../api/party/party.actions';

import DeleteAccount from '../../../components/screens/auth/delete-account/DeleteAccount';

const DeleteAccountContainer = () => {
  const [accountDeleted, setAccountDeleted] = useState(false);

  const dispatch = useDispatch();

  const deleteAccount = (email, password) => {
    dispatch(
      requestLogin({
        input: { email, password },
        deleteAccount: true,
        onSuccess: (personExternalReference) => {
          dispatch(
            requestDeleteUserDetails({
              personExternalReference,
              email,
              onSuccess: () => setAccountDeleted(true),
            })
          );
        },
      })
    );
  };

  return <DeleteAccount accountDeleted={accountDeleted} deleteAccount={deleteAccount} />;
};

export default DeleteAccountContainer;
